import React, { Component } from 'react';
import { Notifier } from '@airbrake/browser';

class ErrorBoundary extends React.Component {
    constructor() {
        super({});
        this.state = { hasError: false };
        this.airbrake = new Notifier({
            projectId: 296371,
            projectKey: '31f317d7fc71fc030a70c24978fa1759'
        });
    }

    componentDidCatch(error, info) {
        // Display fallback UI
        this.setState({ hasError: true });
        // Send error to Airbrake
        this.airbrake.notify({
            error: error,
            params: {info: info}
        });
    }

    render() {
        if (this.state.hasError) {
            // You can render any custom fallback UI
            return <h1>Something went wrong.</h1>;
        }
        return this.props.children;
    }
}

export default ErrorBoundary;